// Vehicle makes grouped by region. Bugatti listed once under French.
export const vehicleMakeGroups = [
  {
    label: "American Brands",
    makes: [
      "Ford", "Chevrolet", "GMC", "Cadillac", "Buick", "Chrysler", "Dodge",
      "Jeep", "Ram", "Tesla", "Lincoln", "Hummer", "Rivian", "Lucid Motors",
    ],
  },
  {
    label: "Japanese Brands",
    makes: [
      "Toyota", "Lexus", "Honda", "Acura", "Nissan", "Infiniti", "Mazda",
      "Subaru", "Mitsubishi", "Suzuki", "Isuzu",
    ],
  },
  {
    label: "German Brands",
    makes: [
      "BMW", "Mercedes-Benz", "Audi", "Volkswagen", "Porsche", "Maybach",
      "Mini", "Smart",
    ],
  },
  {
    label: "Korean Brands",
    makes: ["Hyundai", "Kia", "Genesis"],
  },
  {
    label: "British Brands",
    makes: [
      "Land Rover", "Range Rover", "Jaguar", "Bentley", "Rolls-Royce",
      "Aston Martin", "McLaren", "Lotus", "MG",
    ],
  },
  {
    label: "Italian Brands",
    makes: ["Ferrari", "Lamborghini", "Maserati", "Fiat", "Alfa Romeo", "Pagani"],
  },
  {
    label: "Swedish Brands",
    makes: ["Volvo", "Polestar", "Koenigsegg"],
  },
  {
    label: "French Brands",
    makes: ["Bugatti", "Peugeot", "Renault", "Citroën"],
  },
  {
    label: "Chinese & EV Brands",
    makes: ["BYD", "NIO", "XPeng", "Geely", "Chery", "Great Wall Motors"],
  },
  {
    label: "Exotic / Specialty Brands",
    makes: ["Rimac", "Spyker", "Saleen", "SSC North America", "Hennessey"],
  },
];

export const defaultVehicleMake = "Toyota";
